var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 6a4 4 0 1 1 8 0v1.5c0 1.34.558 2.441 1.093 3.19.079.11.158.214.235.31H2.673c.077-.096.155-.2.234-.31C3.442 9.942 4 8.84 4 7.5V6Zm2 6H1.5a.5.5 0 0 1-.313-.89l.002-.001.012-.01.053-.047a6.012 6.012 0 0 0 .839-.943C2.558 9.46 3 8.56 3 7.5V6a5 5 0 1 1 10 0v1.5c0 1.06.442 1.959.907 2.61a6.013 6.013 0 0 0 .839.942l.053.047.012.01h.001A.5.5 0 0 1 14.5 12H10v1a2 2 0 1 1-4 0v-1Zm3 0H7v1a1 1 0 1 0 2 0v-1Z",
    clipRule: "evenodd"
  })));
};
export default SvgNotification;